<div class="users-and-ba-container">
    <div class="description color-neutral-900">
        {{ 'userProfile.baReports.tab.description' | translate }}
    </div>
    @if (isLoadingUsers) {
        <div class="loading-spinner-section">
            <div class="pi-dashboard_loading-indicator" style="display: block">
                <p>
                    {{ 'label.common-terms.loading' | translate }}
                </p>
                <div class="spinner spinner--person"></div>
            </div>
        </div>
    } @else {
        <div class="users-container color-neutral-900">
            @for (user of usersCollection; track user) {
                <div class="user-row">
                    <span>{{ user.getPartialDisplayName() }}</span>
                    @if (user.personId) {
                        <span class="ba-download color-primary">
                            @if (!isDownloading) {
                                <abstract-icon
                                    class="downloadbottom-icon"
                                    [iconType]="IconType.DownloadBottom"
                                    [iconSize]="IconSize.Medium"
                                >
                                </abstract-icon>
                            } @else {
                                <span class="spinner-dots"></span>
                            }
                            <span
                                (click)="downloadReport(user)"
                                class="download-text"
                                >{{
                                    'userProfile.baReports.tab.download'
                                        | translate
                                }}</span
                            >
                        </span>
                    } @else {
                        <span class="color-neutral-700">{{
                            'userProfile.baReports.tab.notAssessed' | translate
                        }}</span>
                    }
                </div>
            }
        </div>
    }
</div>
